import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-homecur",
  "use": "icon-homecur-usage",
  "viewBox": "0 0 60.3 65.8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 60.3 65.8\" id=\"icon-homecur\">\n<style type=\"text/css\">\n\t\n</style>\n<path class=\"st0\" d=\"M30.2,5c0.2,0,0.5,0.1,0.8,0.3l0.2,0.2l0.2,0.1l24.1,19.8c0.3,0.4,0.2,0.9,0.2,1l-0.2,0.6V60\n\tc0,0.6-0.5,1.2-1.2,1.2H6.1c-0.6,0-1.2-0.5-1.2-1.2V27.1l-0.2-0.6c0-0.1,0-0.2,0-0.3c0-0.3,0.2-0.6,0.3-0.7L29.1,5.7l0.2-0.1\n\tl0.2-0.2C29.7,5.1,30,5,30.2,5 M30.2,0.3c-1.5,0-3,0.6-4.1,1.7L1.7,22C1.4,22.3,0,23.8,0,26.2c0,0.6,0.1,1.1,0.2,1.6V60\n\tc0,3.2,2.6,5.9,5.9,5.9h48.3c3.2,0,5.9-2.6,5.9-5.9V27.8c0.5-2,0-4.2-1.5-5.7l-24.4-20C33.2,0.9,31.7,0.3,30.2,0.3z\" />\n<path class=\"st1\" d=\"M41.2,55.3h-22c-1.6,0-2.9-1.3-2.9-2.9c0-1.6,1.3-2.9,2.9-2.9h22c1.6,0,2.9,1.3,2.9,2.9\n\tC44.2,54,42.8,55.3,41.2,55.3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/homecur.svg
// module id = L1eP
// module chunks = 59